import React from "react";
import styles from "./Episode.module.css";
import {
  FaChevronDown,
  FaHeart,
  FaBookmark,
  FaSave,
  FaCloudUploadAlt,
  FaEdit,
} from "react-icons/fa";
import { navigate } from "hookrouter";
import { useEpisodes } from "./EpisodeHooks";
import { useStory } from "../Story/StoryHooks";
import Loading from "../Loading";
import AuthContext from "../../contexts/AuthContext";

const Header = ({
  storyID,
  episodeID,
  voteForEpisode,
  addBookmark,
  episodeTitle,
  create,
  myStory,
}) => {
  const [open, setOpen] = React.useState(false);
  const { user } = React.useContext(AuthContext);
  const toggleOpen = () => setOpen((prev) => !prev);
  const [episode, setEpisode] = React.useState({});
  const [episodes, loading] = useEpisodes(storyID);
  const [isMyStory, setIsMyStory] = React.useState(myStory);
  const [voteDisabled, setVoteDisabled] = React.useState(false);
  console.log(myStory);
  const [story, loadingStory] = useStory(
    storyID,
    myStory
      ? {
        sub: "searchMine",
      }
      : {}
  );

  React.useEffect(() => {
    setEpisode(episodes.filter((e) => e._id === episodeID)[0]);
  }, [episodes, episodeID]);

  React.useEffect(() => {
    if (episode?.Story) {
      setIsMyStory(episode.Story.postedBy.author === user._id);
    }
  }, [episode]);

  return (
    <div className={styles.header}>
      {!loadingStory ? (
        <div className={styles.novelTitle}>{story.title}</div>
      ) : (
          <Loading transparent={true} />
        )}

      <div className={styles.right}>
        {episodeTitle && (
          <React.Fragment>
            <button className={styles.publish} name="publish" onClick={create}>
              <FaCloudUploadAlt /> Publish
            </button>
            <button className={styles.save} onClick={create}>
              <FaSave />
              Save
            </button>
          </React.Fragment>
        )}

        {episode && (
          <React.Fragment>
            <button 
              onClick={() => {
                setVoteDisabled(true);
                voteForEpisode();
              }} 
              className={styles.heart} 
              disabled={voteDisabled}>
              <FaHeart />
            </button>
            <button className={styles.bookmark} onClick={addBookmark}>
              <FaBookmark />
            </button>
          </React.Fragment>
        )}

        <div className={styles.switcher + " " + (open ? styles.open : "")}>
          {!loading ? (
            <button onClick={toggleOpen}>
              {episode ? episode.episodeName : episodeTitle} <FaChevronDown />
            </button>
          ) : (
              <Loading transparent={true} />
            )}

          {open && (
            <div className={styles.options}>
              {episodes.map((e) => (
                <div
                  onClick={() => {
                    navigate(`/episode/${storyID}/${e._id}`);
                    toggleOpen();
                  }}
                  className={
                    !episodeTitle && e.episodeName === episode.episodeName
                      ? styles.current
                      : ""
                  }
                >
                  {e.episodeName}
                </div>
              ))}
              {!episodeTitle && isMyStory && (
                <div
                  onClick={() => {
                    navigate(`/episode/update/${storyID}/${episodeID}`);
                    toggleOpen();
                  }}
                  className={styles.add}
                >
                  <FaEdit /> Edit Episode
                </div>
              )}
              {episodeTitle && (
                <div
                  onClick={() => {
                    // navigate(`/episode/${storyID}/${e._id}`);/d
                    toggleOpen();
                  }}
                  className={styles.add}
                >
                  <FaSave /> Save and add new
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
